// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3dngL","col":"styles_col__1u_42"};